import React, { useEffect, useState } from "react";
import _ from "lodash";
import moment from "moment";
import { EVENT_PLANNING_RESERVE_CAPACITY } from "../../../plannerConfig";
import {
  SplitPanelContainer,
  SplitPanel,
  PeakInboundItem,
  PeakInboundDate,
  PeakInboundFigure,
  FigureLabel,
  FigureNumbers,
} from "./styles";
import {
  MultiWeekPlannerMainContainer,
  AssumptionSummaryText,
  TableSection,
  VisualisationSection,
} from "../multiWeekStyles.common";
import Visualisation from "../../Visualisations";
import LoadSpinnerOverlay from "../../LoadSpinner";
import { NoDataMessage, NoVisualisationDataWrapper } from "../styles";
import { asFormattedValue } from "../../../helpers";

const ReserveCapacity = ({
  api,
  store,
  fromDate,
  toDate,
  fromDateFilter,
  toDateFilter,
  durationAggregator,
  selectedScenarios,
  scenarioStringBuilder,
}) => {
  const { data, loadingQueue } = store[EVENT_PLANNING_RESERVE_CAPACITY];
  const { CallOut, GraphA } = data;
  const [prefConfig, setPrefConfig] = useState("line");

  const getReserveCapacity = () => {
    const { get } = api;
    if (fromDate && toDate) {
      get([EVENT_PLANNING_RESERVE_CAPACITY], {
        routeParams: {
          fromDate,
          toDate,
          fromDateFilter,
          toDateFilter,
          durationAggregator,
          scenarios: scenarioStringBuilder(selectedScenarios),
        },
      });
    }
  };

  useEffect(() => {
    getReserveCapacity();
  }, [
    fromDate,
    toDate,
    durationAggregator,
    fromDateFilter,
    toDateFilter,
    selectedScenarios,
  ]);

  if (loadingQueue.length || _.isEmpty(data)) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <LoadSpinnerOverlay
          text="Reserve Capacity Data Loading..."
          spinning={true}
        />
      </div>
    );
  }
  const { title: calloutTitle, data: calloutData } = CallOut;

  const parseDate = (date) => {
    const parsedDate = moment(date, "ddd DD/MM/YYYY").format("ddd DD/MM/YY");
    return parsedDate;
  };

  const onChangePrefConfig = (value) => {
    setPrefConfig(value);
  };

  const visualisationData = {
    ...GraphA,
    data: GraphA,
    prefConfig,
    onChangePrefConfig,
  };

  return (
    <MultiWeekPlannerMainContainer>
      <div style={{ display: "flex", flex: 0.5 }}>
        <TableSection>
          <AssumptionSummaryText>{calloutTitle}</AssumptionSummaryText>
          <div style={{ flex: 1 }}>
            <SplitPanelContainer style={{}}>
              <SplitPanel>
                <div
                  style={{
                    overflow: "auto",
                    flex: 1,
                    height: "calc(100vh - 13em - 32px - 64px)",
                    maxHeight: "calc(100vh - 13em - 32px - 64px)",
                  }}
                >
                  {!calloutData.length ? (
                    <NoVisualisationDataWrapper>
                      <NoDataMessage>No Data.</NoDataMessage>
                    </NoVisualisationDataWrapper>
                  ) : (
                    calloutData.map(({ amount, capacity, date, area }) => {
                      return (
                        <PeakInboundItem>
                          <PeakInboundDate>{date}</PeakInboundDate>
                          <PeakInboundFigure>
                            <FigureLabel>{area}</FigureLabel>
                            <FigureNumbers>{`${asFormattedValue(
                              amount
                            )} of ${asFormattedValue(
                              capacity
                            )}`}</FigureNumbers>
                          </PeakInboundFigure>
                        </PeakInboundItem>
                      );
                    })
                  )}
                </div>
              </SplitPanel>
            </SplitPanelContainer>
          </div>
        </TableSection>
      </div>
      <div style={{ display: "flex", flex: "1" }}>
        <VisualisationSection>
          <Visualisation {...visualisationData} />
        </VisualisationSection>
      </div>
    </MultiWeekPlannerMainContainer>
  );
};

export default ReserveCapacity;
